"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VapiClient = void 0;
const Client_1 = require("./api/resources/calls/client/Client");
const Client_2 = require("./api/resources/assistants/client/Client");
const Client_3 = require("./api/resources/phoneNumbers/client/Client");
const Client_4 = require("./api/resources/squads/client/Client");
const Client_5 = require("./api/resources/knowledgeBases/client/Client");
const Client_6 = require("./api/resources/blocks/client/Client");
const Client_7 = require("./api/resources/tools/client/Client");
const Client_8 = require("./api/resources/files/client/Client");
const Client_9 = require("./api/resources/analytics/client/Client");
const Client_10 = require("./api/resources/logs/client/Client");
class VapiClient {
    constructor(_options = {}) {
        this._options = _options;
    }
    get calls() {
        var _a;
        return ((_a = this._calls) !== null && _a !== void 0 ? _a : (this._calls = new Client_1.Calls(this._options)));
    }
    get assistants() {
        var _a;
        return ((_a = this._assistants) !== null && _a !== void 0 ? _a : (this._assistants = new Client_2.Assistants(this._options)));
    }
    get phoneNumbers() {
        var _a;
        return ((_a = this._phoneNumbers) !== null && _a !== void 0 ? _a : (this._phoneNumbers = new Client_3.PhoneNumbers(this._options)));
    }
    get squads() {
        var _a;
        return ((_a = this._squads) !== null && _a !== void 0 ? _a : (this._squads = new Client_4.Squads(this._options)));
    }
    get knowledgeBases() {
        var _a;
        return ((_a = this._knowledgeBases) !== null && _a !== void 0 ? _a : (this._knowledgeBases = new Client_5.KnowledgeBases(this._options)));
    }
    get blocks() {
        var _a;
        return ((_a = this._blocks) !== null && _a !== void 0 ? _a : (this._blocks = new Client_6.Blocks(this._options)));
    }
    get tools() {
        var _a;
        return ((_a = this._tools) !== null && _a !== void 0 ? _a : (this._tools = new Client_7.Tools(this._options)));
    }
    get files() {
        var _a;
        return ((_a = this._files) !== null && _a !== void 0 ? _a : (this._files = new Client_8.Files(this._options)));
    }
    get analytics() {
        var _a;
        return ((_a = this._analytics) !== null && _a !== void 0 ? _a : (this._analytics = new Client_9.Analytics(this._options)));
    }
    get logs() {
        var _a;
        return ((_a = this._logs) !== null && _a !== void 0 ? _a : (this._logs = new Client_10.Logs(this._options)));
    }
}
exports.VapiClient = VapiClient;
